import { render, staticRenderFns } from "./MarginCustomsV2.vue?vue&type=template&id=6ee8691b"
import script from "./MarginCustomsV2.vue?vue&type=script&lang=js"
export * from "./MarginCustomsV2.vue?vue&type=script&lang=js"
import style0 from "./MarginCustomsV2.vue?vue&type=style&index=0&id=6ee8691b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports